import React, { useEffect, useContext, useState } from 'react';
import { Flexbox, Button } from '@sede-enterprise/shell-ds-react-framework';
import { counterPartyFilter } from '../../../../api/services';
import { AppContext } from '../../../../Context/AppContext';
import { PPASelectFormField } from '../../PPAInsights/PPAInsightFilterSection/PPASelectFormField';
import { SelectFormField } from '../../../ReUsableComponents/SelectFormField/SelectFormField';
import { REGION_NAMES, COMMODITY_POWER_SHORT_NAME } from './../../../../api/constants';
import { ICiTradeFilteredValues } from '../../../../Types/types';
import { getCombinedMonths } from '../../../Utils/utils'; // Adjust the import path as necessary

const asiaJapanRegionName = REGION_NAMES.ASIA_JAPAN;

export const CiTradeFilterSection = () => {
  const { state: analyticsState, dispatch: analyticsDispatch } =
    useContext(AppContext).ciTradeAndVolume;
  const { state } = useContext(AppContext).appData;
  const filterData = analyticsState.ciTradeFilterOptions;

  const [yearSelected, setYearSelected] = useState<string[]>(['2024']);
  const [quarterSelected, setQuarterSelected] = useState<string[]>([]);
  const [monthSelected, setMonthSelected] = useState<string[]>([]);
  const [regionSelected, setRegionSelected] = useState<string[]>([asiaJapanRegionName]);
  const [unitNameSelected, setUnitNameSelected] = useState('MWH');
  const [commoditySelected, setCommoditySelected] = useState('PW');

  useEffect(() => {
    const fetchData = async () => {
      const response = await counterPartyFilter();
      analyticsDispatch({
        type: 'setCiTradeFilterOptions',
        payload: response.data,
      });
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!filterData) {
    return null; // or a loading spinner
  }

  const handleApplyFilters = () => {
    const payload: ICiTradeFilteredValues = {
      year: yearSelected,
      quarter: quarterSelected,
      month: monthSelected,
      region: [asiaJapanRegionName],
      uom: unitNameSelected ?? '',
      commodity: commoditySelected ? [commoditySelected] : [COMMODITY_POWER_SHORT_NAME],
    };

    analyticsDispatch({ type: 'setCiTradeFilteredValues', payload });
  };

  const handleClearFilters = () => {
    setYearSelected(['2024']);
    setQuarterSelected([]);
    setMonthSelected([]);
    setRegionSelected([asiaJapanRegionName]);
    setUnitNameSelected('MWH');
    setCommoditySelected(COMMODITY_POWER_SHORT_NAME);

    const payload: ICiTradeFilteredValues = {
      year: ['2024'],
      quarter: [],
      month: [],
      region: [asiaJapanRegionName],
      commodity: [COMMODITY_POWER_SHORT_NAME],
      uom: 'MWH',
    };

    analyticsDispatch({ type: 'setCiTradeFilteredValues', payload });
  };

  // Filter data for commodity. Only show Power commodity for CI Trades
  const optionsData = filterData.commodity
    .filter((el) => el.TRADE_CODE === COMMODITY_POWER_SHORT_NAME)
    .map((el: { TRADE_NAME: string; TRADE_CODE: string }) => {
      return { label: el.TRADE_NAME, value: el.TRADE_CODE };
    });

  return (
    <div data-testid='filter' style={{ padding: '20px', width: '25%' }}>
      <Flexbox flexDirection='column'>
        <div
          style={{
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '17px',
            lineHeight: '26px',
            color: '#404040',
            padding: '10px 0',
            marginTop: '26px',
            width: '251px',
          }}
        >
          Filters
        </div>
        <PPASelectFormField
          id='year'
          label='Year'
          testId='Year'
          value={yearSelected}
          onChange={setYearSelected}
          options={filterData.year}
          mode='multiple'
        />
        <PPASelectFormField
          id='quarter'
          label='Quarter'
          testId='Quarter'
          value={quarterSelected}
          onChange={setQuarterSelected}
          options={filterData.quarter}
          mode='multiple'
        />
        {quarterSelected.length > 0 && (
          <PPASelectFormField
            id='month'
            label='Month'
            testId='Month'
            value={monthSelected}
            onChange={setMonthSelected}
            options={getCombinedMonths(quarterSelected)}
            mode='multiple'
          />
        )}
        <PPASelectFormField
          id='region'
          label='Region'
          testId='Region'
          value={regionSelected}
          onChange={setRegionSelected}
          options={[asiaJapanRegionName]}
          mode='multiple'
          disabled={state.isNcfReportingRegionFieldDisabled}
        />
        <PPASelectFormField
          id='unitName'
          label='Unit Name'
          testId='Unit Name'
          value={unitNameSelected}
          onChange={setUnitNameSelected}
          options={filterData.unitName}
        />
        <SelectFormField
          id='commodity'
          label='Commodity'
          testId='Commodity'
          value={commoditySelected}
          onChange={setCommoditySelected}
          options={optionsData}
          mode='single'
        />
        <Button className='getDataBtn' data-testid='Apply Filters' onClick={handleApplyFilters}>
          Apply Filters
        </Button>
        <Button
          className='getDataBtn'
          variant='outlined'
          style={{ marginTop: '10px' }}
          data-testid='Clear Filters'
          onClick={handleClearFilters}
        >
          Clear Filters
        </Button>
      </Flexbox>
      <div style={{ borderLeft: '1px solid rgba(0, 0, 0, 0.06)' }}></div>
    </div>
  );
};